import styled from "styled-components";
import {GameJackpotValueDefaultBox} from "./game-jackpot-value.default.box";

export const GameJackpotValueSIBox = styled(GameJackpotValueDefaultBox)`
    width: 100%;
    background-color: ${props => props.theme.colors.brandSecondary};
    color: ${props => props.theme.colors.moneyColor};
    padding: 2px 0;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
`;